/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */

import React, { useState, useEffect } from "react";
import { InfiniteStoryBase, WithPreview } from "@quintype/components";
import { BlankStory } from "../story-templates/blank";

import { VideoStory } from "../story-templates/video";
import { PhotoStory } from "../story-templates/photo";
import { LiveBlogStory } from "../story-templates/live-blog";
import { number, object, shape, array } from "prop-types";
import metypeConfig from "../../../../config/metype-config";
import get from "lodash/get";
import BottomSticky from "../molecules/bottom-sticky";
import loadTaboolaScript, { removeTaboolaScript } from "../../components/taboola-ad/load-taboola-ad";

import { storyPageLoadItems } from "../utils/api";
import { DfpAd } from "../dfp-ad";

function StoryPageBase({ index, story, mostPopular, params }) {
  // Can switch to a different template based story-template, or only show a spoiler if index > 0
  const getTemplate = () => {
    if (story["story-template"] === "live-blog") {
      return (
        <LiveBlogStory
          story={story}
          mostPopular={index === 0 ? mostPopular : mostPopular}
          metypeConfig={metypeConfig}
          cardId={get(params, ["cardId"])}
        />
      );
    } else if (story["story-template"] === "video") {
      return (
        <VideoStory story={story} mostPopular={index === 0 ? mostPopular : mostPopular} metypeConfig={metypeConfig} />
      );
    } else if (story["story-template"] === "photo") {
      return (
        <PhotoStory story={story} mostPopular={index === 0 ? mostPopular : mostPopular} metypeConfig={metypeConfig} />
      );
    } else {
      return (
        <BlankStory story={story} mostPopular={index === 0 ? mostPopular : mostPopular} metypeConfig={metypeConfig} />
      );
    }
  };

  return (
    <React.Fragment>
      {getTemplate()}
      <BottomSticky next={true} story={story} />
    </React.Fragment>
  );
}

StoryPageBase.propTypes = {
  index: number,
  story: object,
  mostPopular: array,
  params: object
};

export function StoryPage(props) {
  useEffect(() => {
    const taboolaSrc = get(props, ["config", "publisher-attributes", "taboola_script"], "");
    const teadScript = get(props, ["config", "publisher-attributes", "tead_script"], "");

    loadTaboolaScript("article", taboolaSrc);

    const script = document.createElement("script");
    script.src = teadScript;
    script.id = "tead-script";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      removeTaboolaScript();

      if (document.getElementById("tead-script")) {
        const teadScriptElement = document.getElementById("tead-script");
        document.body.removeChild(teadScriptElement);
      }
    };
  }, []);

  return (
    <div className="story-container">
      {/* <div
        className="hide-xs"
        style={{
          height: "600px",
          width: "160px",
          position: "fixed",
          left: 0
        }}
      >
        <DfpAd adtype="NH_Article_LHS_Sticky" />
      </div> */}
      <InfiniteStoryBase
        {...props}
        render={StoryPageBase}
        loadItems={pageNumber => storyPageLoadItems(pageNumber, props.data.mostPopular)}
        onInitialItemFocus={item =>
          app.registerPageView({ pageType: "story-page", data: { story: item.story } }, `/${item.story.slug}`)
        }
        onItemFocus={item => console.log(`Story In View: ${item.story.headline}`)}
      />
    </div>
  );
}

StoryPage.propTypes = {
  data: shape({
    story: object
  })
};

export const StoryPagePreview = WithPreview(StoryPage, (data, story) =>
  Object.assign({}, data, {
    story,
    mostPopular: Array(5).fill(story)
  })
);
